import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import NotifyTakeAppointmentDelay from "./NotifyTakeAppointmentDelay";
import {Button, InputAdornment} from "@mui/material";
import {ArrowDownward, CalendarMonth, CheckCircle} from "@mui/icons-material";
import NotifyInterventionDelay from "./NotifyInterventionDelay";
import {MobileDateTimePicker} from "@mui/x-date-pickers";
import {DemoItem} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import BeneficiaryContact from "./BeneficiaryContact";
import isNull from "../../../../../../mixin/isNull";
import PictureList from "./PictureList";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import useAlert from "../../../../../../use/useAlert";
import LoadingData from "../common/LoadingData";
import {ZonedDateTime, ZoneId} from "@js-joda/core";
import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import AppointmentPlanningSolver from "./AppointmentPlanningSolver";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import parameter from "../../../../../../enum/parameter";

const ERROR_APPOINTMENT_REQUIRED = "Veuillez renseigner le rendez-vous.";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const alert = useAlert();
    const eventDispatcher = useEventDispatcher();
    const qualityInspectionRepository = useQualityInspectionRepository();
    /** @type QualityInspection */
    const qualityInspection = qualityInspectionRepository.findOneById(qualityInspectionId).select();
    const [loading, setLoading] = useState(false);
    const [openAppointmentPlanningModal, setOpenAppointmentPlanningInitiator] = useState(false);
    const [nextStepAvailable, setNextStepAvailable] = useState(false);
    const nextStepButtonRef = useRef();
    const appointmentInput = useRef();
    const appointmentPlanningInitiator = useRef();

    useEffect(() => {
        qualityInspectionRepository.findOneById(qualityInspectionId).exec();
    }, []);

    useEffect(() => {
        if (!nextStepAvailable) return;

        eventDispatcher.launcher("next-step-available");
    }, [nextStepAvailable]);

    const toggleAppointmentPlanningModal = o => () => setOpenAppointmentPlanningInitiator(o);

    const nextStep = async () => {
        setLoading(true);

        if (isNull(appointmentInput.current)) {
            alert.warning(ERROR_APPOINTMENT_REQUIRED);
            setLoading(false);
            return;
        }

        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_APPOINTMENT,
                appointment_planning_initiator: appointmentPlanningInitiator.current
            },
            intervention: {
                appointment: appointmentInput.current.toISOString()
            }
        });

        if (!res) setLoading(false);
    }

    const handleAppointmentPlanningChange = response => {
        appointmentPlanningInitiator.current = response;

        toggleAppointmentPlanningModal(false)();

        setNextStepAvailable(true);
    }

    const handleAppointmentAccepted = (val) => {
        if (isNull(val)) return;

        appointmentInput.current = dayjs(val);
        appointmentPlanningInitiator.current = null;

        if (isAppointmentGreaterThan2Hours()) {
            toggleAppointmentPlanningModal(true)();
        } else {
            setNextStepAvailable(true);
        }
    }

    const isAppointmentGreaterThan2Hours = () => {
        const appointment = ZonedDateTime.parse(appointmentInput.current.toISOString()).withZoneSameInstant(ZoneId.of("Europe/Paris"));

        return appointment.toEpochSecond() >= ZonedDateTime.now().plusHours(2).toEpochSecond();
    }

    if (isNull(qualityInspection)) return <LoadingData/>;

    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyTakeAppointmentDelay/>
                </Box>
                <Box mt={1}>
                    <NotifyInterventionDelay/>
                </Box>
                <Box mt={4}>
                    <BeneficiaryContact clientId={clientId} qualityInspectionId={qualityInspectionId}/>
                </Box>
                <Box px={2} mt={5}>
                    <DemoItem label={"Renseignez le rendez-vous dans le champ ci-dessous"}>
                        <MobileDateTimePicker
                            ampm={false}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarMonth/>
                                            </InputAdornment>
                                        ),
                                    },
                                    "data-test": "input-appointment"
                                }
                            }}
                            onAccept={handleAppointmentAccepted}
                        />
                    </DemoItem>
                </Box>
                <Box mt={3}>
                    <PictureList orderId={orderId}/>
                </Box>
            </Body>
            <Footer>
                <PopperWrapper
                    elementRef={nextStepButtonRef}
                    placement={"bottom"}
                    content={"Vous pouvez passer à l'étape suivante"}
                    triggeringEvent={"next-step-available"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowDownward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading || !nextStepAvailable}
                    ref={nextStepButtonRef}
                    data-test="button-next-step"
                >
                    Valider le rendez-vous
                </Button>
            </Footer>

            {
                openAppointmentPlanningModal
                    ? (
                        <Modal
                            modalConfig={
                                new ModalConfig()
                                    .setHeight("100%")
                                    .setWidth("100%")
                                    .setOnClose(toggleAppointmentPlanningModal(false))
                                    .setComponent(<AppointmentPlanningSolver onChange={handleAppointmentPlanningChange}/>)
                                    .setShowCloseButton(false)
                            }
                        />
                    )
                    : null
            }
        </>
    )
}